/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import intl from 'react-intl-universal';
import { Redirect, withRouter } from 'react-router-dom';

import QueryNavbar from "../components/AppNavbar";
import Loading from "../components/Loading";
import { renderMetaTagsForFingHelp } from "../helpers/MetaTagsHelper";
import {isUserSignedIn, isUserProfileLoaded, UserContext, getLinkForSignIn} from "../UserContext";

import { getOsPrintableIconClass, getOsPrintableVersion } from '../helpers/DevRecogHelper';
import { formatSmartAbsoluteDate } from '../helpers/DateHelper';

import PromoImg from "../assets/svg/manypixels/complete_task_1.svg";

import './HelpTicket.css';
import TicketNotFound from "./TicketNotFound";
import NodeHelper from "../helpers/NodeHelper";
import { SEG_LOCAL, SEG_NETWORK, SEG_INTERNET } from "./HealthCheckConstants";
import { CDN_IMAGES_URL } from '../Constants';


const NT_ETHERNET = 'ETHERNET';
const NT_ETH_USB = 'USB_ETHERNET';
const NT_WIFI = 'WIFI';

// const fakeTicket = {
//     ticketId: "C6564B1B984D8820",
//     // state: "NEW",
//     state: "OPEN",
//     userId: "god@fing.io",
//     creationDate: 1586343251000,
//     closeDate: 0,
//     sharedUserIds: null,
//     sharePIN: 234567890,
//     newTicketCommunityUser: null,
//     communityDiscussionId: 23,
//     commInfo: null,
//     title: "winzoozzo",
//     description: "winnsaszzxSDASDASDASCAS",
//     privacy: "PRIVACY_NONE",
//     healthCheck: {
//         timestamp: 1586343032375,
//         id: "5C:E0:C5:69:51:401586343032375",
//         network: {
//             address_type: "NTYPE_ETHWIFI",
//             name: "fing-eero",
//             context: "HOME",
//             bssid: "F8:BB:BF:8A:C4:43",
//             additionalbssids: [
//                 "F8:BB:BF:1B:12:06",
//                 "F8:BB:BF:1B:12:07",
//                 "F8:BB:BF:1B:12:08",
//                 "F8:BB:BF:8A:C4:44",
//                 "BC:15:AC:8E:1B:81"
//             ],
//             address: "192.168.1.0/24",
//             mask_prefix_length: 24,
//             gateway_ip_address: "192.168.1.1",
//             dns_address: "8.8.8.8"
//         },
//         nicinfos: [
//             {
//                 name: "\Device\NPF_{95BEE0CF-6516-4D8D-A1A8-DB14033C6033}",
//                 description: "Intel(R) Dual Band Wireless-AC 7265",
//                 hardwareaddress: "5C:E0:C5:69:51:40",
//                 address: "192.168.1.253",
//                 netmask: "192.168.1.0/24",
//                 type: "WIFI",
//                 state: "ACTIVE",
//                 addrmode: "STATIC",
//                 dhcpserver: null,
//                 uplinknominalrate: 117000000,
//                 downlinknominalrate: 117000000,
//                 uplinkeffectiverate: 117000000,
//                 downlinkeffectiverate: 117000000,
//                 apbssid: "F8:BB:BF:8A:C4:43",
//                 apssid: "fing-eero",
//                 signalstrength: -60,
//                 channel: 1,
//                 gatewayAddress: "192.168.1.1",
//                 defaultGateway: true,
//                 advanced: false
//             }
//         ],
//         internetinfo: {
//             isp: {
//                 address: "2.39.131.X",
//                 host_name: null,
//                 organization: "Vodafone Italia DSL",
//                 isp: "Vodafone Italia DSL",
//                 country_name: "Italy",
//                 country_region: "Latium",
//                 country_code: "IT",
//                 country_city: "Rome",
//                 continent_code: "EU",
//                 asn: "30722"
//             },
//             ispinfo: {
//                 id: "vodafone",
//                 countrycode: "IT",
//                 name: "Vodafone",
//                 logoimageurl: "/isp/IT/logo/vodafone_logo.png",
//                 bannerimageurl: "",
//                 business: true,
//                 fiber: true,
//                 cellular: true,
//                 residential: true,
//                 organization: false,
//                 ispstats: {
//                     country: "IT",
//                     city: "Rome",
//                     isp: "Vodafone",
//                     downloadSpeedMbpsAvg: 37.41997619777662,
//                     uploadSpeedMbpsAvg: 15.131154433267174,
//                     samples: 339,
//                     downloadSpeedMbpsMin: 0.039,
//                     uploadSpeedMbpsMin: 0.156,
//                     downloadSpeedMbpsMax: 441.744,
//                     uploadSpeedMbpsMax: 270.265,
//                     downloadSpeedMbpsStd: 40.30105107688978,
//                     uploadSpeedMbpsStd: 18.073911141601226,
//                     score: 0.464,
//                     type: "BOX_MOBILE_WIFI",
//                     sentiment: 47,
//                     totalRatings: 21,
//                     globalScore: 0.496,
//                     distribution: 0.11147648799736928,
//                     ispId: "Vodafone",
//                     countryCode: "IT",
//                     countryRegion: "",
//                     downloadSpeedTrend: 0.11175809986467218,
//                     uploadSpeedTrend: 0.34335698903366585,
//                     scoreTrend: 0,
//                     globalScoreTrend: 0,
//                     sentimentTrend: -0.12962962962962962,
//                     distributionTrend: -0.015480608553845827
//                 }
//             }
//         },
//         self: {
//             mac_address: "5C:E0:C5:69:51:40",
//             address_list: [
//                 "192.168.1.11",
//                 "192.168.1.250",
//                 "192.168.1.251",
//                 "192.168.1.252",
//                 "192.168.1.253"
//             ],
//             state: "UP",
//             favorite: false,
//             important: false,
//             firstseentime: 1583845327917,
//             statechangetime: 1586181399114,
//             best_name: "fing-Latitude-E7450",
//             best_type: "LAPTOP",
//             best_make: "Dell",
//             best_model: "LATITUDE E7450",
//             best_os: "Windows",
//             best_osver: "10 Pro",
//             recog_rank: 100,
//             mac_vendor: "Intel"
//         },
//         gateway: {
//             mac_address: "BC:15:AC:8E:1B:81",
//             address_list: [
//                 "192.168.1.1"
//             ],
//             state: "UP",
//             favorite: false,
//             important: true,
//             firstseentime: 1507737085513,
//             statechangetime: 1584109603222,
//             best_name: "Vodafone Station",
//             best_type: "ROUTER",
//             best_make: "Vodafone",
//             best_model: "Revolution",
//             best_os: null,
//             best_osver: null,
//             recog_rank: 80,
//             mac_vendor: "Vodafone"
//         },
//         checks: [
//             {
//                 segment: "local",
//                 type: "001",
//                 status: "OK",
//                 info: "Current IP is 192.168.1.253",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "002",
//                 status: "OK",
//                 info: null,
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "004",
//                 status: "OK",
//                 info: "Computer local time is synchronized",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "005",
//                 status: "OK",
//                 info: "DNS Servers 8.8.8.8 1.1.1.1",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "006",
//                 status: "OK",
//                 info: "Current Gateway IP is 192.168.1.1",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "007",
//                 status: "OK",
//                 info: "Wi-Fi signal is good: 66%",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "009",
//                 status: "OK",
//                 info: "Connected to a Wireless network",
//                 muted: "false"
//             },
//             {
//                 segment: "local",
//                 type: "00A",
//                 status: "INFO",
//                 info: "Additional DNS on Computer: 1.1.1.1/8.8.8.8",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "401",
//                 status: "OK",
//                 info: "Local network is 192.168.1.253/24 via Intel(R) Dual Band Wireless-AC 7265",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "403",
//                 status: "OK",
//                 info: "Route to Primary DNS 8.8.8.8 via Intel(R) Dual Band Wireless-AC 7265",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "404",
//                 status: "OK",
//                 info: "Route to Secondary DNS 1.1.1.1 via Intel(R) Dual Band Wireless-AC 7265",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "405",
//                 status: "OK",
//                 info: "Route to 192.168.1.1 via Intel(R) Dual Band Wireless-AC 7265",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "406",
//                 status: "OK",
//                 info: "Home network netmask is good: 192.168.1.0/24, up to 256 devices",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "407",
//                 status: "OK",
//                 info: "Current Gateway MAC is BC:15:AC:8E:1B:81",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "40B",
//                 status: "INFO",
//                 info: null,
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "40E",
//                 status: "INFO",
//                 info: null,
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "40F",
//                 status: "OK",
//                 info: null,
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "410",
//                 status: "OK",
//                 info: "Network has 14/60 online devices",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "411",
//                 status: "INFO",
//                 info: "Network Gateway is Vodafone / Revolution",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "415",
//                 status: "OK",
//                 info: "Active DHCP is 192.168.1.1 (BC:15:AC:8E:1B:81) on 192.168.1.0/24",
//                 muted: "false"
//             },
//             {
//                 segment: "network",
//                 type: "416",
//                 status: "OK",
//                 info: "Lease time 1 hour, DNS 192.168.1.1, MTU not set, Domain station",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "801",
//                 status: "OK",
//                 info: "Connected to Internet via Vodafone in Italy, Internet IP 2.39.131.4",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "802",
//                 status: "OK",
//                 info: "Test domain ieee.org resolved by 8.8.8.8",
//                 muted: "true"
//             },
//             {
//                 segment: "internet",
//                 type: "804",
//                 status: "OK",
//                 info: "www.google.com is browsable",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "805",
//                 status: "OK",
//                 info: "www.amazon.com is browsable",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "806",
//                 status: "OK",
//                 info: "www.netflix.com is browsable",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "807",
//                 status: "OK",
//                 info: "www.facebook.com is browsable",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "808",
//                 status: "OK",
//                 info: "web.whatsapp.com is browsable",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "809",
//                 status: "OK",
//                 info: "Vodafone had no widespread outage in the last 7 days",
//                 muted: "false"
//             },
//             {
//                 segment: "internet",
//                 type: "80C",
//                 status: "OK",
//                 info: "outlook.office.com is browsable",
//                 muted: "false"
//             }
//         ],
//         errorCode: null
//     },
//     ownerLevel: true,
//     accessLog: [{totalAccess: 12, lastAccess: 123444443, communityName: 'Pablo', userName: 'Pablo2'}],
//     netSummary: {
//         lastDiscoveryTime: 1586343099586,
//         totDevices: 15,
//         devices: [
//             {
//                 type: "ROUTER",
//                 profile: "Networking",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "STB",
//                 profile: "DigitalMedia",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "MOBILE",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "TABLET",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "STREAMING_DONGLE",
//                 profile: "DigitalMedia",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "MOBILE",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "VOICE_CONTROL",
//                 profile: "SmartHome",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "LAPTOP",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "SURVEILLANCE_CAMERA",
//                 profile: "Protection",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "LAPTOP",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "SURVEILLANCE_CAMERA",
//                 profile: "Protection",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "LAPTOP",
//                 profile: "Personal",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "FINGBOX",
//                 profile: "SmartHome",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "ROUTER",
//                 profile: "Networking",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "WIFI",
//                 profile: "Networking",
//                 up: true,
//                 recent: false
//             },
//             {
//                 type: "STREAMING_DONGLE",
//                 profile: "DigitalMedia",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "VOICE_CONTROL",
//                 profile: "SmartHome",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "GAME_CONSOLE",
//                 profile: "Gaming",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "LAPTOP",
//                 profile: "Personal",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "MOBILE",
//                 profile: "Personal",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "MOBILE",
//                 profile: "Personal",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "GENERIC",
//                 profile: "Other",
//                 up: false,
//                 recent: false
//             },
//             {
//                 type: "LAPTOP",
//                 profile: "Personal",
//                 up: false,
//                 recent: false
//             }
//         ],
//         stats: [
//             {
//                 name: "NETWORKSIZE",
//                 caption: "NetworkSize",
//                 value: 23,
//                 scoreValue: 2
//             },
//             {
//                 name: "NETWORKING",
//                 caption: "Networking",
//                 value: 3,
//                 scoreValue: 2
//             },
//             {
//                 name: "IT",
//                 caption: "IT",
//                 value: 0,
//                 scoreValue: 0
//             },
//             {
//                 name: "PROTECTION",
//                 caption: "Protection",
//                 value: 2,
//                 scoreValue: 2
//             },
//             {
//                 name: "PERSONAL",
//                 caption: "Personal",
//                 value: 10,
//                 scoreValue: 2
//             },
//             {
//                 name: "DIGITALMEDIA",
//                 caption: "DigitalMedia",
//                 value: 3,
//                 scoreValue: 2
//             },
//             {
//                 name: "SMARTHOME",
//                 caption: "SmartHome",
//                 value: 3,
//                 scoreValue: 2
//             },
//             {
//                 name: "GAMING",
//                 caption: "Gaming",
//                 value: 1,
//                 scoreValue: 2
//             }
//         ],
//         speedTest: {
//             timestamp: 1585557158964,
//             downloadBps: 44251000,
//             uploadBps: 18644000,
//             rtd: 19
//         }
//     }
// };

class ViewHelpTicketView extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isFound: false,
            isUnauthorized: false,
            selectedFilter: null,
            showDeleteCloseModal: false,
            modal: null,
            ticket: null
        };

        // Bindings
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
    }

    componentDidMount() {
      this.mainFetchSequence();
    }

    mainFetchSequence() {
        const url = '/rest/internet/helpme/helpticket/' + this.props.match.params.ticketid;
        // return this.setState({ ticket: fakeTicket, isLoading: false, isFound: true, isUnauthorized: false });
        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => {
                console.log(response);
                return response.json();
            })
            .then(data => {
                this.setState({ ticket: data, isLoading: false, isFound: true, isUnauthorized: false });
            })
            .catch(e => this.catchRestError(e));
    }
     
    // --------------------------------------------------------------------------------
    // HANDLER
    // --------------------------------------------------------------------------------

    handleChangeFilter(event) {
        event.preventDefault();
        this.setState({ selectedFilter: event.currentTarget.id });
    }

    handleSubmit(event, isDelete) {
        event.preventDefault();
        const newTicket = Object.assign({}, this.state.ticket);
        newTicket.state = isDelete ? 'DELETED' : 'CLOSED';

        let url = '/rest/internet/helpme/manageticket';
        
        fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newTicket)
        })
            .then(response => {
                console.log('Response: ', response);
                this.setState({ showDeleteCloseModal: false, modal: null });
                if (isDelete && this.props.history) {
                    this.props.history.push('/helpme/view');
                } else {
                    this.mainFetchSequence();
                }
            })
            .catch(error => {
                this.setState({ showDeleteCloseModal: false, modal: null })
            });
    };

    handleFormSubmit(event) {
        event.preventDefault();

        const formPIN = event.target['formPIN'] ? event.target['formPIN'].value : '';
        const url = '/rest/internet/helpme/reqaccess/' + this.props.match.params.ticketid + '/' + formPIN;

        console.log('calling GET: ' + url);

        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => {
                return response.json();
            })
            .then(data => {
                return fetch('/rest/internet/helpme/helpticket/' + this.props.match.params.ticketid);
            })
            .then(response => this.validateRestResponse(response))
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ ticket: data, isLoading: false, isFound: true, isUnauthorized: false });
            })
            .catch(e => this.catchRestError(e))
            ;
    };

    // --------------------------------------------------------------------------------
    // UTILS
    // --------------------------------------------------------------------------------

    validateRestResponse(response) {
        if (response.status !== 200) {
            if (response.status === 401)
                this.setState({ isUnauthorized: true });
            throw new Error(response.statusText);
        }
        return response;
    }

    catchRestError(error) {
        console.error(error);
        this.setState({ isLoading: false, isFound: false });
    }

    countTypeOfCheck(checks) {
        let counter = {
            all: checks.length,
            ok: 0,
            info: 0,
            warn: 0,
            fail: 0
        };

        for (const check of checks) {
            switch (check.status) {
                case 'OK':
                    counter.ok++;
                    break;
                case 'INFO':
                    counter.info++;
                    break;
                case 'WARN':
                    if (check.muted === 'false') counter.warn++;
                    else counter.info++;
                    break;
                case 'FAIL':
                    counter.fail++;
                    break;
                default:
                    break;
            }
        }
        return counter;
    }

    addVirtualCheck(checks, beforeSegment, virtualCheck) {
        virtualCheck.muted = 'false';
        let pos = 0;
        for (; pos < checks.length; ++pos) {
            if (checks[pos].segment === beforeSegment) 
                break;
        }
        checks.splice(pos, 0, virtualCheck);
    }

    parseEthernetAnswer(rate) {
        const number = Number(rate) / 1000000;
        if (number === 10000) return "10 Gbit";
        else if (number === 1000) return "1 Gbit";
        else if (number === 100) return "100 Mbit";
        else if (number === 10) return "10 Mbit";
        return number.toFixed(1) + " Mbit";
    }


    // --------------------------------------------------------------------------------
    // ANCILLARY RENDER FUNCTION
    // --------------------------------------------------------------------------------

    renderNotSignedUser(context) {
        return (
            <div>
                {renderMetaTagsForFingHelp("Fing Query " + this.props.match.params.ticketid,
                    "Query " + this.props.match.params.ticketid + " on Fing: see detailed report and help troubleshoot connectivity problems.")}
                <QueryNavbar />
                <main id="content" role="main">
                    <div className="container space-bottom-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <div className="card shadow-sm p-7">
                                <h1 className="font-weight-semi-bold text-primary">Access to Fing query</h1>
                                <h1 className="h6 text-secondary">You need to login to your Fing account in order to access to Fing queries.</h1>
                                <span>
                                    <a className="btn btn-primary btn-pill btn-wide transition-3d-hover mt-5"
                                       href={getLinkForSignIn(context, window.location.href)}>Login to access to Fing queries</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    renderUnauthorizedUser() {
        return (
            <div>
                <QueryNavbar />
                <main id="content" role="main">
                    <div className="container space-bottom-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <div className="card shadow-sm p-7">
                                <h1 className="card-title font-weight-semi-bold text-primary">Access this query</h1>
                                <form className="card-body" onSubmit={this.handleFormSubmit}>
                                    <div className="form-group">
                                        <label className="h6" for="formPIN">PIN</label>
                                        <input id="formPIN" className="form-control" type="text" defaultValue={this.state.pin} placeholder="Enter PIN" required />
                                    </div>
                                    <input className="btn btn-primary" type="submit" name="Access Query" />
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    renderActions(ticket) {
        if (!ticket.ownerLevel) 
            return;

        const canCloseIt = ticket.state === 'OPEN';
        return (
            <div>
                <div className="d-inline-block">
                    <a className="btn btn-xs btn-outline-charcoal" data-toggle="modal" data-target="#action" href="/#" onClick={(e) => {
                        e.preventDefault(); 
                        this.setState({ modal: "DELETE" })
                    }}>
                        <span className="fas fa-trash fa-fw mr-2" /> Delete
                    </a>
                </div>
                {canCloseIt &&
                    <div className="d-inline-block ml-2">
                        <a className="btn btn-xs btn-outline-charcoal" data-toggle="modal" data-target="#action" href="/#" onClick={(e) => {
                            e.preventDefault();
                            this.setState({ modal: "CLOSE" });
                        }}>
                            <span className="fas fa-check fa-fw mr-2" />Resolve
                        </a>
                    </div>}
            </div>
        );
    }

    renderTicketHeader(ticket) {
        return (
            <section id="Ticket_Header" className="row align-items-center">
                <div className="col-md-8 mb-3 mb-md-0">
                    <div className="small text-muted">
                        {formatSmartAbsoluteDate(ticket.creationDate)}
                        {ticket.state === 'CLOSED' && "  •  Closed on " + formatSmartAbsoluteDate(ticket.closeDate)}
                    </div>
                    <h5 className="h5 mb-0">Fing query <a className="link-underline" href={'https://query.fing.com/' + ticket.ticketId}>{ticket.ticketId}</a>
                        <span className="badge badge-success ml-2 my-auto">{ticket.state}</span></h5>
                </div>
                <div className="col-md-4 text-md-right">
                    {this.renderActions(ticket)}
                </div>
            </section>
        )
    }

    renderTicketDetails(ticket) {
        const roleText = ticket.ownerLevel ? 'Owner of the query' : 'Shared with you';
        const detailLvl = (ticket.privacy === 'PRIVACY_NONPERSONAL') ? 'Non-personal details' : 
            (ticket.privacy === 'PRIVACY_MAX') ? 'Minimal details' : 
            'All details';
        return (
            <section id="Ticket_Details" className="d-md-flex align-items-md-center mt-2">
                <div className="mb-3 mb-md-0">
                    <h3 className="small text-secondary mb-0">
                        <small className="fas fa-user-alt text-secondary align-middle mr-1" />
                        {roleText}</h3>
                </div>
                <div className="column-divider column-divider--none-md pl-4 mb-3 mb-md-0 ml-2">
                    <h3 className="small text-secondary mb-0">
                        <small className="fas fa-search text-secondary align-middle mr-2" />
                        {detailLvl}</h3>
                </div>
            </section>
        );
    }

    renderTicketTitle(ticket) {
        return (
            <section id="Ticket_Title" className="alert alert-soft-primary mt-4">
                <div className="small text-muted">What's this about?</div>
                <h4 className="alert-heading">{ticket.title}</h4>
                <p className="mb-4">{ticket.description}</p>
            </section>
        )
    }

    renderCommunityInfo(ticket) {
        if (!ticket.communityDiscussionId || ticket.communityDiscussionId === '') 
            return;

        const communityLink = "https://community.fing.com/discussion/" + ticket.communityDiscussionId;
        const totalComments = ticket.commInfo ? ticket.commInfo.totalComments : 0;
        const totalViews = ticket.commInfo ? ticket.commInfo.totalViews : 0;

        return (
            <section id="Ticket_Community_Info">
                <ul className="list-inline d-flex align-items-center">
                    <li className="list-inline-item">
                        <a className="btn btn-xs btn-soft-primary" href={communityLink} target="_blank" rel="noopener noreferrer">
                            <span className="far fa-comment mr-1"/>Add comment
                        </a>
                    </li>
                    <li className="list-inline-item ml-auto">
                        <a className="text-secondary small" href={communityLink} target="_blank" rel="noopener noreferrer" >
                            <span className="far fa-comments mr-1" />{totalComments} Comments
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a className="text-secondary small" href={communityLink} target="_blank" rel="noopener noreferrer" >
                            <span className="far fa-eye mr-1" /> {totalViews} Views
                        </a>
                    </li>
                </ul>
            </section>
        );
    }

    renderAccessLog(log, rowid, communityMode) {
        const uid = communityMode && log.communityName ? log.communityName : log.userName;
        return (
            <div><small className="text-muted">{log.totalAccess} views by {uid}, last at {formatSmartAbsoluteDate(log.lastAccess)}</small></div>
        );
    }

    renderOwnerLevelInfo(ticket) {
        if (!ticket.ownerLevel) 
            return;
        const communityMode = ticket.communityDiscussionId != null;
        return (
            <section  id="Ticket_Owner_Info">
                {ticket.sharePIN && <h1 className="h4 text-dark">Share PIN: <b>{ticket.sharePIN}</b></h1>}
                {(ticket.accessLog && ticket.accessLog.length > 0) &&
                    ticket.accessLog.map((l, index) => this.renderAccessLog(l, index + 1, communityMode))
                }
            </section>
        );
    }

    renderPie(perc) {
        return <pie className={`${perc === 100 ? 'pie100' : perc > 50 ? 'pie75' : perc > 25 ? 'pie50' : perc > 0 ? 'pie25' : 'pie0'}`} />;
    }

    renderOverviewItem(item, index) {
        const name = item[0];
        const icon = NodeHelper.getBestIcon(name);

        const color = item[1] > 0 ? 'text-dark' : 'text-secondary';
        const imgColor = item[1] > 0 ? "1" : "0.4";

        const upPerc = (item[1] / item[2]) * 100;
       
        return (
            <div className="p-2 row " style={{ minWidth: "130px" }}>
                <div className="online-item mr-2 mt-1 d-block">
                    {upPerc > 0 && this.renderPie(upPerc)}
                    <img width="32" height="32" src={icon} style={{ opacity: imgColor }} alt={name}/>
                </div>
                <span className={"mt-1 h5 " + color}> {item[1]}
                    <small className="text-secondary">/{item[2]}</small>
                </span>
            </div>
        );
    }

    renderOverviewRow(row, index) {

        const DeviceProfileIcons = {
            "NetworkSize": "fa-wifi",
            "Personal": "fa-user-alt",
            "DigitalMedia": "fa-play",
            "Gaming": "fa-gamepad",
            "Protection": "fa-shield-alt",
            "IT": "fa-server",
            "Networking": "fa-sitemap",
            "SmartHome": "fa-home",
            "Business": "fa-shopping-bag",
        };

        const name = row[0];

        let profIcon;
        if (name === 'New') {
            profIcon = 'fa-burn';
        } else if (name === 'Other') {
            profIcon = 'fa-dot-circle';
        } else {
            profIcon = DeviceProfileIcons[name];
        }

        let countOnline = 0, countRecent = 0;

        let items = [];
        for (var key in row[1]) {
            let devFam = row[1][key];
            countOnline += devFam[0];
            countRecent += devFam[1];
            if (devFam[1] < 1) 
                continue;
            items.push([key, devFam[0], devFam[1], devFam[2], devFam[3]]);
        }

        items.sort(function (a, b) {
            let diff = b[2] - a[2];
            if (diff !== 0) 
                return diff;
            diff = b[1] - a[1];
            if (diff !== 0) 
                return diff;
            return b[0] - a[0];
        });

        const upPerc = (countOnline / countRecent) * 100;
        const profColor = name === 'New' ? 'bg-primary' : countOnline > 0 ? 'bg-soft-primary' : 'bg-soft-secondary';
        const profTxtColor = name === 'New' ? 'text-primary' : countOnline > 0 ? 'text-charcoal' : 'text-secondary';
        const faColor = name === 'New' ? 'text-white' : 'text-charcoal';

        return (
            <div key={"nets-" + index} className="media align-items-left">
                <div className="media align-items-flex-center p-2">
                    <div className={`avatar rounded text-center ${profColor} mt-0 mr-3`}>
                        <span className={`fas ${profIcon} fa-fw fa-lg align-bottom ${faColor}`} />
                        {this.renderPie(upPerc)}
                    </div>
                    <div className="media-body mt-2" style={{ minWidth: "130px" }}>
                        <h4 className={'h6 ' + profTxtColor}>{name}</h4>
                    </div>
                </div>
                {items.map((item, index) => this.renderOverviewItem(item, index))}
            </div>
        );
    }

    renderNetworkSummary(ticket) {
        
        const netSummary = ticket.netSummary;
        const devices = ticket.netSummary.devices;

        let OverviewRows = {
            "New": {},
            "Personal": {},
            "DigitalMedia": {},
            "Gaming": {},
            "SmartHome": {},
            "Protection": {},
            "Business": {},
            "IT": {},
            "Networking": {},
            "Other": {},
        };

        let totalOnline = 0, totalDevices = 0;
        for (let i = 0; i < devices.length; ++i) {
            const node = devices[i];
            ++totalDevices;
            const prof = node.profile;
            let row = OverviewRows[prof];
            if (!row[node.type]) row[node.type] = [0, 0, 0, []];
            row[node.type][2] = row[node.type][2] + 1;
            if (node.up) {
                ++totalOnline;
                row[node.type][0] = row[node.type][0] + 1;
                row[node.type][1] = row[node.type][1] + 1;
                if (row[node.type][3].length < 10) row[node.type][3].push(node);
            } else {
                row[node.type][1] = row[node.type][1] + 1;
            }

            // check also recent
            if (node.recent) {
                const prof = 'New';
                let row = OverviewRows[prof];
                const devType = node.type;
                if (!row[devType]) row[devType] = [0, 0, 0, []];
                row[devType][2] = row[devType][2] + 1;
                if (node.up) {
                    row[devType][0] = row[devType][0] + 1;
                    row[devType][1] = row[devType][1] + 1;
                    if (row[devType][3].length < 10) row[devType][3].push(node);
                } else {
                    row[devType][1] = row[devType][1] + 1;
                }
            }
        }

        let rows = [];
        for (var key in OverviewRows) {
            let value = OverviewRows[key];
            if (Object.keys(value).length > 0) rows.push([key, value]);
        }

        return (
            <section id="Ticket_Network_Summary">
                <div className="row mb-3">
                    <div className="col-md-12">
                        <h4 className="h5 mb-0">Network details</h4>
                        <p className="small">{totalOnline}/{totalDevices} devices online, scanned on {formatSmartAbsoluteDate(netSummary.lastDiscoveryTime)}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {rows.map((r, index) => this.renderOverviewRow(r, index))}
                    </div>
                </div>
            </section>
        );
    }

    renderSpeed(text, speed, color, dir) {
        return (
            <div className="media mr-4">
                <span className={`btn btn-icon btn-soft-${color} rounded-circle mr-3`}>
                    <span className={`fas fa-arrow-${dir}`} />
                </span>
                <div className="media-body">
                    <h4 className="h5 font-weight-normal mb-0">{speed} <span className="text-secondary">Mbps</span></h4>
                    <span className="d-block text-secondary font-size-1">{text}</span>
                </div>
            </div>
        )
    }

    renderSpeedTestSummary(ticket) {
        const speedTest = ticket.netSummary.speedTest;
        const download = (speedTest.downloadBps / 1000000).toFixed(1);
        const upload = (speedTest.uploadBps / 1000000).toFixed(1);
        return (
            <section id="Ticket_Speedtest">
                <div className='row mb-3'>
                    <div className="col-md-12">
                        <h4 className='mb-0'>Internet performance</h4>
                        <p className='small'>Last measured on {formatSmartAbsoluteDate(speedTest.timestamp)}</p>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12">
                        <div className="media justify-content-center align-items-center mb-3">
                            {this.renderSpeed("Download Speed", download, "success", "down")}
                            {this.renderSpeed("Upload Speed", upload, "primary", "up")}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    renderHealthCheckHeader() {
        const { ticket } = this.state;
        return (
            <section id="Ticket_Healthcheck_Header">
                <h4 className="mb-0">Connectivity health report</h4>
                {ticket && ticket.healthCheck && <p className='small'>Checked on {formatSmartAbsoluteDate(ticket.healthCheck.timestamp)}</p>}
            </section>
        );
    }

    renderHealthCheckSummary() {
        const { ticket } = this.state;

        if (!ticket || !ticket.healthCheck || (ticket.healthCheck.checks && ticket.healthCheck.checks.length === 0)) return '';

        let checksByStatus = ticket.healthCheck.checks
            .reduce(function (acc, check) {
                if (check.muted === 'false') acc[check.status] = acc[check.status] + 1 || 1;
                acc['TOTAL'] = acc['TOTAL'] + 1 || 1;
                return acc;
            }, {});


        const totFails = (checksByStatus['FAIL'] || 0);
        const totWarns = (checksByStatus['WARN'] || 0);

        let text = "", codeText, codeDescr, summaryIcon, alertType;
        
        if (totFails > 0) {
            alertType = "danger";
            let failsBySegment =
                ticket.healthCheck.checks.filter(c => c.status === 'FAIL')
                    .reduce(function (acc, check) {
                        acc[check.segment] = acc[check.segment] + 1 || 1;
                        return acc;
                    }, {});
            const totLocal = (failsBySegment['local'] || 0);
            const totNetwork = (failsBySegment['network'] || 0);
            const totInternet = (failsBySegment['internet'] || 0);

            if (totLocal > 0 && totNetwork > 0 && totInternet > 0) {
                text = 'Device is not connected to a wired or wireless network.'
            } else if (totLocal === 0 && totNetwork === 0 && totInternet > 0) {
                text = 'Device is connected to the network, but network has limited connectivity: Internet is not reachable.'
            } else if (totLocal === 0 && totNetwork > 0 && totInternet === 0) {
                text = 'Device is connected to the network and Internet is reachable, but network is experiencing issues.'
            } else {
                text = 'There is a number of issues to be fixed.';
            }

            codeText = ticket.healthCheck.errorCode ? (': code ' + ticket.healthCheck.errorCode) : '';
            summaryIcon = "fa-times";
            codeDescr = "Connectivity Problems";
            
        } else if (totWarns > 0) {
            alertType = "warning";
            let warnsBySegment =
                ticket.healthCheck.checks.filter(c => c.status === 'WARN' && c.muted === 'false')
                    .reduce(function (acc, check) {
                        acc[check.segment] = acc[check.segment] + 1 || 1;
                        return acc;
                    }, {});
            const totLocal = (warnsBySegment['local'] || 0);
            const totNetwork = (warnsBySegment['network'] || 0);
            const totInternet = (warnsBySegment['internet'] || 0);

            if (totLocal > 0) {
                text += 'Warnings in device configuration. '
            }
            if (totNetwork > 0) {
                text += 'Network is working but something needs attention. '
            }
            if (totInternet > 0) {
                text += 'Internet is reachable but check some possible issue. '
            }

            codeText = ticket.healthCheck.errorCode ? (': code ' + ticket.healthCheck.errorCode) : '';
            codeDescr = "Connectivity Warnings";
            summaryIcon = "fa-exclamation";
            
        } else {
            alertType = "";
            codeDescr = "Flawless connectivity";
            codeText = "";
            text = <span className="text-gray">Health check on Fing Desktop did not detect any problem or warning.</span>;
            summaryIcon = "fa-check";
        }

        return (
            <section id="Ticket_Healthcheck_Summary">
                <div className={`alert ${alertType}`} role="alert">
                    <div className="d-flex align-items-center">
                        <div className="pr-4">
                            <div className={`btn btn-block btn-icon btn-${alertType || "success"}`}>
                                <span className={`fas ${summaryIcon} text-white`}/>
                            </div>
                        </div>
                        <div className="flex-lg-grow-1 mr-4">
                            <h5 className="alert-heading">{codeDescr}{codeText}</h5>
                            {text}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    renderCheckState(check, isRunning, rowId) {
        let color;
        let text;
        let icon;
        switch (check.status) {
            case 'OK':
                color = 'badge-success';
                text = 'Passed';
                icon = "fa-check";
                break;
            case 'INFO':
                color = 'badge-secondary';
                text = 'Info';
                icon = "fa-info";
                break;
            case 'SKIP':
                color = 'badge-muted';
                text = isRunning ? "Pending" : 'Skipped';
                icon = isRunning ? 'fa-sync' : "fa-asterisk";
                break;
            case 'WARN':
                if (check.muted === 'false') {
                    color = 'badge-warning';
                    text = 'Warning';
                    icon = "fa-exclamation";
                } else {
                    color = 'badge-secondary';
                    text = 'Muted';
                    icon = "fa-bell-slash";
                }
                break;
            case 'FAIL':
                color = 'badge-danger';
                text = 'Failed';
                icon = "fa-times";
                break;
            default:
                color = 'badge-dark';
                icon = isRunning ? 'fa-sync' : 'fa-asterisk';
                text = isRunning ? "Pending" : check.status;
                break;
        }

        return <span key={"checkState_" + rowId} className={"badge " + color}><span className={"fas fa-fw mr-2 " + icon} />{text}</span>
    }

    renderSelf(check, rowId) {
        const device = this.state.ticket.healthCheck.self;
        const detail = NodeHelper.bestMakeAndModelAsArray(device);

        let deviceOs, deviceOsIcon;
        if (device && device.best_os) {
            deviceOsIcon = getOsPrintableIconClass(device.best_os);
            deviceOs = device.best_os;
            if (device.best_osver) {
                let ver = getOsPrintableVersion(device.best_os, device.best_osver);
                deviceOs += ' ' + (ver ? ver : device.best_osver);
            }
        }

        const icon = NodeHelper.getBestIcon(device.best_type);
        let info = 'Your device, ' + device.best_name + ' (' + device.mac_address + ')';
        return (
            <tr role="row" key={"self_" + rowId} className=''>
                <td>{this.renderCheckState(check, false, rowId)}</td>
                <td className="text-center">
                    <img src={icon} height={24} className={"d-block mx-auto"} alt="Self"/>
                    <small className="text-secondary">you</small>
                </td>
                <td><span>
                    {
                        detail && detail.length >= 2 &&
                        <span className="">{detail[0]} • {detail[1]}</span>
                    }
                    {
                        detail && detail.length === 1 &&
                        <span className="">{detail[0]}</span>
                    }
                    {
                        deviceOs &&
                        <span className="">{detail && detail.length ? ' • ' : ''}
                            {deviceOsIcon ? <span className={"fab fa-fw " + deviceOsIcon} /> : ''}{deviceOs}</span>
                    }

                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderGateway(check, rowId) {
        const device = this.state.ticket.healthCheck.gateway;
        let detail = NodeHelper.bestMakeAndModelAsArray(device);
        if (detail.length === 0 && device.mac_vendor) detail = [device.mac_vendor];

        let deviceOs, deviceOsIcon;
        if (device && device.best_os) {
            deviceOsIcon = getOsPrintableIconClass(device.best_os);
            deviceOs = device.best_os;
            if (device.best_osver) {
                let ver = getOsPrintableVersion(device.best_os, device.best_osver);
                deviceOs += ' ' + (ver ? ver : device.best_osver);
            }
        }

        const icon = NodeHelper.getBestIcon(device.best_type);
        let info = 'Network gateway';
        if (device.mac_address) info += ' ' + device.mac_address;
        if (device.address_list && device.address_list.length > 0) info += ' (' + device.address_list[0] + ')';

        return (
            <tr role="row" key={"gateway_" + rowId} className=''>
                <td>{this.renderCheckState(check, false, rowId)}</td>
                <td className="text-center">
                    <img src={icon} height={24} className={"d-block mx-auto"} alt="Gateway"/>
                    <small className="text-secondary">gateway</small>
                </td>
                <td><span>
                    {
                        detail && detail.length >= 2 &&
                        <span className="">{detail[0]} • {detail[1]}</span>
                    }
                    {
                        detail && detail.length === 1 &&
                        <span className="">{detail[0]}</span>
                    }
                    {
                        (!detail || detail.length === 0) &&
                        <span className="">Network gateway</span>
                    }
                    {
                        deviceOs &&
                        <span className="">{detail && detail.length ? ' • ' : ''}
                            {deviceOsIcon ? <span className={"fab fa-fw " + deviceOsIcon} /> : ''}{deviceOs}</span>
                    }

                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderNetworkInfo(check, rowId) {
        const net = this.state.ticket.healthCheck.network;
        let icon = "fa-network-wired";

        const nif = this.state.ticket.healthCheck.nicinfos[0];
        if (nif && nif.type === NT_WIFI) {
            icon = "fa-wifi";
        } else {
            icon = "fa-network-wired";
        }
        let ctxTxt = 'Generic';
        if (net.context) {
            if (net.context === 'HOME') { icon = "fa-home"; ctxTxt = 'Home'; }
            else if (net.context === 'OFFICE') { icon = "fa-briefcase"; ctxTxt = 'Office'; }
            else if (net.context === 'PUBLIC') { icon = "fa-coffee"; ctxTxt = 'Public'; }
            else if (net.context === 'RENTAL') { icon = "fa-bed"; ctxTxt = 'Rental'; }
        }

        let info = net.address;
        let descr = ctxTxt + ' network';
        var totAps = 0;
        var bssidsTxt = '';
        if (net.bssid) {
            ++totAps;
            bssidsTxt = net.bssid;
            if (net.additionalbssids && net.additionalbssids.length > 0) {
                for (var i = 0; i < net.additionalbssids.length; ++i) {
                    bssidsTxt += ', ' + net.additionalbssids[i];
                    ++totAps;
                }
            }
        }
        if (net.address_type === 'NTYPE_WIFI') {
            info = 'Wireless network ' + net.address + ' with ' + totAps + ' BSSID: ' + bssidsTxt;
        } else if (net.address_type === 'NTYPE_ETHWIFI') {
            info = 'Wired and Wireless network ' + net.address + ' with ' + totAps + ' BSSID: ' + bssidsTxt;
        } else if (net.address_type === 'NTYPE_ETHERNET') {
            info = 'Wired network ' + net.address;
        }

        return (
            <tr role="row" key={"network_" + rowId} className=''>
                <td>{this.renderCheckState(check, false, rowId)}</td>
                <td className="text-center">
                    {icon && <span className={"d-block mx-auto fas " + icon} />}
                    <small className="text-secondary">network</small>
                </td>
                <td><span>
                    <span className="">{descr}</span>
                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderIspInfo(check, rowId) {
        const isp = this.state.ticket.healthCheck.internetinfo.isp;
        const ispInfo = this.state.ticket.healthCheck.internetinfo.ispinfo;
        let icon = CDN_IMAGES_URL + "/isp/general/default_isp.png";
        if (ispInfo.bannerimageurl) {
            icon = CDN_IMAGES_URL + this.state.ticket.healthCheck.internetinfo.ispinfo.bannerimageurl;
        } else if (ispInfo.logoimageurl) {
            icon = CDN_IMAGES_URL + this.state.ticket.healthCheck.internetinfo.ispinfo.logoimageurl;
        }
        let ispName = ispInfo.name ? ispInfo.name : isp.isp ? isp.isp : isp.organization;
        let bestLoc = isp.country_city ? isp.country_city : isp.country_name ? isp.country_name : '';
        if (ispInfo.ispstats) bestLoc = ispInfo.ispstats && ispInfo.ispstats.city ? ispInfo.ispstats.city : ispInfo.ispstats.country ? ispInfo.ispstats.country : '';
        let descr = "ISP is " + ispName + " in " + bestLoc + ', public IP ' + isp.address;

        let info = 'No detailed stats available for this ISP';
        if (ispInfo.ispstats) {
            info = 'ISP average speed in location is download ' + (Number(ispInfo.ispstats.downloadSpeedMbpsAvg)).toFixed(1) + ' Mbps, ';
            info += ' upload ' + (Number(ispInfo.ispstats.uploadSpeedMbpsAvg)).toFixed(1) + ' Mbps, ';
            info += ' market share of ' + (Number(ispInfo.ispstats.distribution) * 100.0).toFixed(1) + '%';

        }

        return (
            <tr role="row" key={"ispInfo_" + rowId} className=''>
                <td>{this.renderCheckState(check, false, rowId)}</td>
                <td className="text-center">
                    <img src={icon} height={24} className={"d-block mx-auto"} alt="ISP"/>
                    <small className="text-secondary">internet</small>
                </td>
                <td><span>
                    <span className="">{descr}</span>
                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderGeoLocInfo(check, rowId) {
        const isp = this.state.ticket.healthCheck.internetinfo.isp;
        let icon = CDN_IMAGES_URL + "/isp/general/default_isp.png";
        if (isp.country_code) {
            icon = CDN_IMAGES_URL + "/flags/1x1/" + isp.country_code.toLowerCase() + ".png";
        }
        let descr = "";
        if (isp.country_city) descr = isp.country_city;
        if (isp.country_region) {
            if (descr.length > 0) descr += ', ';
            descr += isp.country_region;
        }
        if (descr.length > 0) descr += ', ';
        descr += isp.country_name;

        let info = 'Internet address located in ' + isp.country_name + (isp.timezone ? ', with time zone ' + isp.timezone : "");

        return (
            <tr role="row" key={"geo_" + rowId} className=''>
                <td>{this.renderCheckState(check, false)}</td>
                <td className="text-center">
                    <img src={icon} height={24} className={"d-block mx-auto"} alt="Geo"/>
                    <small className="text-secondary">location</small>
                </td>
                <td><span>
                    <span className="">{descr}</span>
                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderNicInfo(check, rowId) {

        const nif = this.state.ticket.healthCheck.nicinfos[0];
        let icon;
        let descr;
        let info = 'Your connection to the network';
        if (nif && nif.type === NT_ETHERNET) {
            icon = require("../assets/icons/dt_poe_plug_lg.png");
            let ethRate = this.parseEthernetAnswer(nif.downlinkeffectiverate);
            descr = "Connected via Ethernet";
            info = "IP address " + nif.address + ', link speed ' + ethRate;
        } else if (nif && nif.type === NT_ETH_USB) {
            icon = require("../assets/icons/dt_usb_lg.png");
            let ethRate = this.parseEthernetAnswer(nif.downlinkeffectiverate);
            descr = "Connected via USB Ethernet";
            info = "IP address " + nif.address + ', link speed ' + ethRate;
        } else if (nif && nif.type === NT_WIFI) {
            icon = require("../assets/icons/dt_wifi_extender_lg.png");
            let band = nif.channel > 14 ? '5 GHz' : '2.4 GHz';
            if (nif.apssid && nif.apbssid) {
                descr = "Connected to Wi-Fi " + nif.apssid + " at " + band;
                info = "IP address " + nif.address + ", Wi-Fi station " + nif.apbssid + ' on channel #' + nif.channel + " at speed " + this.parseEthernetAnswer(nif.downlinkeffectiverate);
            } else {
                descr = "Connected via Wi-Fi at " + band;
                info = "IP address " + nif.address + ", Wi-Fi channel #" + nif.channel + " at speed " + this.parseEthernetAnswer(nif.downlinkeffectiverate);
            }

        } else {
            descr = "Not connected";
        }

        return (
            <tr role="row" key={"nic_" + rowId} className=''>
                <td>{this.renderCheckState(check, false, rowId)}</td>
                <td className="text-center">
                    <img src={icon} height={24} className={"d-block mx-auto"} alt="NIC"/>
                    <small className="text-secondary">link</small>
                </td>
                <td><span>
                    <span className="">{descr}</span>
                    <br /><small className="text-secondary">{info}</small></span></td>
            </tr>);
    }

    renderHealthCheck(check, rowid, isRunning) {
        const { ticket } = this.state;

        if (check.segment === "virtual") {
            if (check.type === "self") {
                return this.renderSelf(check, rowid);
            } else if (check.type === "gateway") {
                return this.renderGateway(check, rowid);
            } else if (check.type === "nicinfo") {
                return this.renderNicInfo(check, rowid);
            } else if (check.type === "geoloc") {
                return this.renderGeoLocInfo(check, rowid);
            } else if (check.type === "isp") {
                return this.renderIspInfo(check, rowid);
            } else if (check.type === "network") {
                return this.renderNetworkInfo(check, rowid);
            }
        }

        let icon = check.segment === SEG_LOCAL ? "fa-laptop" : 
                    check.segment === SEG_NETWORK ? "fa-network-wired" :
                        check.segment === SEG_INTERNET ? "fa-cloud" : "fa-server";

        let img;

        if (check.segment === SEG_NETWORK) {
            const nicinfos = ticket.healthCheck.nicinfos;
            const nif = nicinfos[0];
            if (nif && nif.type === NT_WIFI) {
                icon = "fa-wifi";
            } else {
                icon = "fa-network-wired";
            }
        } else if (check.segment === SEG_INTERNET &&
            ticket.healthCheck.internetinfo &&
            ticket.healthCheck.internetinfo.ispinfo &&
            ticket.healthCheck.internetinfo.ispinfo != null) {
            const ispInfo = ticket.healthCheck.internetinfo.ispinfo;
            if (ispInfo.bannerimageurl) {
                icon = null;
                img = CDN_IMAGES_URL + ticket.healthCheck.internetinfo.ispinfo.bannerimageurl;
            } else if (ispInfo.logoimageurl) {
                icon = null;
                img = CDN_IMAGES_URL + ticket.healthCheck.internetinfo.ispinfo.logoimageurl;
            }
        }

        let bgclass = ['OK', 'SKIP', 'INFO'].includes(check.status) ? '' :
            check.status === 'WARN' ? 'bg-soft-warning' : 'bg-soft-danger';

        if (check.status === 'WARN' && check.muted === 'true') bgclass = '';

        let localDescr = intl.get("healthcheck_" + check.type + "_" + (['OK', 'SKIP', 'INFO'].includes(check.status) ? "G" : "B"));

        return (
            <tr role="row" key={rowid} className={bgclass}>
                <td>{this.renderCheckState(check, isRunning, rowid)}</td>
                <td className="text-center">
                    {img && <img className={"d-block mx-auto"} src={img} height={24} alt="Check"/>}
                    {icon && <span className={"d-block mx-auto fas " + icon} />}
                    <small className="text-secondary">{check.segment}</small>
                </td>
                <td><span>{localDescr}<br /><small className="text-secondary">{check.info}</small></span></td>
            </tr>);
    }

    renderHealthCheckList() {
        const { ticket } = this.state;
        if (!ticket || !ticket.healthCheck || (ticket.healthCheck.checks && ticket.healthCheck.checks.length === 0)) 
            return ;
        let checks = ticket.healthCheck.checks.filter(c => c.status !== 'SKIP');

        // add virtuals >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        if (ticket.healthCheck.self) {
            this.addVirtualCheck(checks, SEG_LOCAL, { segment: "virtual", type: "self", status: "INFO" });
        }

        if (ticket.healthCheck.internetinfo &&
            ticket.healthCheck.internetinfo.isp &&
            ticket.healthCheck.internetinfo.isp.country_name) {
            this.addVirtualCheck(checks, SEG_INTERNET, { segment: "virtual", type: "geoloc", status: "INFO" });
            if (ticket.healthCheck.internetinfo.ispinfo &&
                (ticket.healthCheck.internetinfo.isp.isp || ticket.healthCheck.internetinfo.isp.organization)) {
                this.addVirtualCheck(checks, SEG_INTERNET, { segment: "virtual", type: "isp", status: "INFO" });
            }
        }

        let { selectedFilter } = this.state;

        const classes = {
            all: "btn btn-xs btn-outline-primary",
            info: "btn btn-xs btn-outline-primary",
            warn: "btn btn-xs btn-outline-primary",
            fail: "btn btn-xs btn-outline-primary"
        };

        const counter = this.countTypeOfCheck(checks);

        if (!selectedFilter) {
            if (counter.fail) {
                selectedFilter = 'FAIL';
            } else if (counter.warn) {
                selectedFilter = 'WARN';
            } else {
                selectedFilter = 'ALL';
            }
        }

        switch (selectedFilter) {
            case "ALL":
                classes.all += " active";
                break;
            case "INFO":
                classes.info += " active";
                break;
            case "WARN":
                classes.warn += " active";
                break;
            case "FAIL":
                classes.fail += " active";
                break;
            default:
                // classes.all += " active";
                break;
        }


        if (ticket.healthCheck.nicinfos && ticket.healthCheck.nicinfos.length > 0) {
            this.addVirtualCheck(checks, SEG_NETWORK, { segment: "virtual", type: "nicinfo", status: "INFO" });
        }

        if (ticket.healthCheck.network) {
            this.addVirtualCheck(checks, SEG_NETWORK, { segment: "virtual", type: "network", status: "INFO" });
        }

        if (ticket.healthCheck.gateway) {
            this.addVirtualCheck(checks, SEG_NETWORK, { segment: "virtual", type: "gateway", status: "INFO" });
        }

        // add virtuals <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

        return (
            <section id="Ticket_Healthcheck_List">
                <div className="text-center my-3">
                    <div className="btn-group btn-group-xs btn-group-toggle" data-toggle="buttons">
                        <label className={classes.all} id="ALL" onClick={this.handleChangeFilter}>
                            <input type="radio" name="options" checked/>All <span className="badge mt-1 badge-primary20 mx-1">{counter.all}</span></label>
                        <label className={classes.info} id="INFO" onClick={this.handleChangeFilter}>
                            <input type="radio" name="options" />Info <span className="badge mt-1 badge-primary20 mx-1">{counter.info}</span></label>
                        <label className={classes.warn} id="WARN" onClick={this.handleChangeFilter}>
                            <input type="radio" name="options" />Warn <span className="badge mt-1 badge-primary20 mx-1">{counter.warn}</span></label>
                        <label className={classes.fail} id="FAIL" onClick={this.handleChangeFilter}>
                            <input type="radio" name="options" />Fail <span className="badge mt-1 badge-primary20 mx-1">{counter.fail}</span></label>
                    </div>
                </div>
                {counter[selectedFilter.toLowerCase()] ?
                    <table
                        className="table table-borderless datatable-striped datatable-content mb-5 dataTable no-footer">
                        <thead>
                            <tr>
                                <th>State</th>
                                <th className="text-center">Where</th>
                                <th>What does Fing check?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {checks.map((c, index) => {
                                if (selectedFilter === 'ALL' ||
                                    (selectedFilter === 'INFO' && c.muted === 'true') ||
                                    (c.status === selectedFilter && c.muted === 'false')) {
                                    return this.renderHealthCheck(c, index + 1, false)
                                }
                                return '';
                            })}
                        </tbody>
                    </table> :
                    <div className="mx-8 text-center">
                        <figure className="mt-7">
                            <div className="card-header border-0 text-center"
                                style={{ opacity: "0.6", backgroundColor: "inherit" }}> 
                                <img className="img-fluid" src={PromoImg} height={"140px"} alt="Promo"/>
                                {/*<h4 className="text-left mt-4 mb-0">Scan your network</h4>*/}
                            </div>
                        </figure>
                        <h4 className="text-secondary">Everything's fine, no {selectedFilter.toLowerCase()} here!</h4>
                        <p>Use the buttons above to select a different group.</p>
                    </div>}
            </section>
        );
    }

    renderDeleteCloseModal() {
        const { modal } = this.state;
        let title = modal && modal === "DELETE" ? "Delete" : "Resolve";
        let text = modal && modal === "DELETE" ? "Do you want to permanently delete this query?" : "Mark this query as resolved?";
        let isDelete = (modal && modal === "DELETE") || false;

        return (
            <div className="modal fade" id="action" tabIndex="-1" role="dialog" aria-labelledby="actionLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="h5 modal-title" id="actionLabel">{title} query</h5>
                        </div>
                        <div className="modal-body bg-light">
                            <p>{text}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-primary"data-dismiss="modal" onClick={(event) => this.handleSubmit(event, isDelete)}>{title}</button>
                            <button type="button" className="btn btn-sm btn-outline-secondary" data-dismiss="modal" >Close</button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    // --------------------------------------------------------------------------------
    // MAIN RENDER
    // --------------------------------------------------------------------------------

    render() {
        const { isLoading, isFound, isUnauthorized, ticket } = this.state;

        if (isLoading || !isUserProfileLoaded(this.context)) {
            return <Loading />
        }

        if (!isUserSignedIn(this.context)) {
            return this.renderNotSignedUser(this.context);
        }

        if (isUnauthorized) {
            return this.renderUnauthorizedUser();
        }

        if (!isFound) {
            if (this.props.match.params.ticketid === '')
                return <Redirect to={'/helpme/list'} />;
            else
                return <TicketNotFound />;
        }

        if (ticket && ticket.state && ticket.state === 'NEW') {
            return (<Redirect to={'/helpme/open/' + ticket.ticketId} />);
        }

        const withNetworkSummary = ticket && ticket.netSummary && ticket.netSummary.devices;
        const withSpeedSummary = ticket && ticket.netSummary && ticket.netSummary.speedTest;

        return (
            <div>
                <QueryNavbar />

                <main id="content" role="main">
                    <div className="container space-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <div className="card shadow-sm p-7">

                                {this.renderTicketHeader(ticket)}
                                {this.renderTicketDetails(ticket)}

                                {this.renderTicketTitle(ticket)}
                                {this.renderCommunityInfo(ticket)}
                                {this.renderOwnerLevelInfo(ticket)}

                                {withNetworkSummary && <hr className="my-5" />}

                                {withNetworkSummary && this.renderNetworkSummary(ticket)}

                                {withSpeedSummary && <hr className="my-5" />}

                                {withSpeedSummary && this.renderSpeedTestSummary(ticket)}

                                <hr className="my-5" />

                                {this.renderHealthCheckHeader()}
                                {this.renderHealthCheckSummary()}
                                {this.renderHealthCheckList()}

                                {this.renderDeleteCloseModal()}
                            </div>

                        </div>
                    </div>
                </main>
            </div>
        );

    }
}

export default withRouter(ViewHelpTicketView);